import React from "react";
import { useTranslation } from 'react-i18next';

const RemovedUser = ({crewCart}) => {
    const { t } = useTranslation();

    const handleClose = () => {
        // Clear local storage
        localStorage.removeItem("crewCartUserId");
        localStorage.removeItem("crewCartToken");

        window.parent.postMessage(
            {type: 'CONTINUE_SHOPPING'},
            'https://' + crewCart.shop.origin_domain
        );
        window.location.reload();

    };

    return (
        <div className="removed-user-container" style={{
            padding: '20px',
            textAlign: 'center',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px'
        }}>
            <h5 style={{ margin: 0 }}>
                {t('removedUser.title')}
            </h5>
            <p>{t('removedUser.description')}</p>
            <button
                className="btn btn-primary-crewcart"
                onClick={handleClose}
                style={{
                    maxWidth: '200px',
                    padding: '10px 20px',
                    height: '42px'
                }}
            >
                {t('removedUser.close')}
            </button>
        </div>
    );
};

export default RemovedUser;
